
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import _ from 'lodash';
    import * as Publicaciones from '@/__env/lib/MercadoLibre/Publicaciones';
    import * as Articulos from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Cuenta, CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;

        public Abierto: boolean = false;

        @Watch( 'Abierto' )
        onAbierto()
        {

            this.Cuenta = '';
            this.Tipo = this.Tipos.find( x => x.Tipo && x.Tipo.Id == this.Controlador.Publicacion.Tipo.Id );
            this.Precio = this.Controlador.Publicacion.Precio;
            this.Stock = this.Controlador.Publicacion.Stock + this.Controlador.Publicacion.Ventas;
        }

        public Cuenta: string = '';
        public get Cuentas()
        {
            return CuentasMercadoLibre;
        }
        public Tipo: { Nombre: string, Tipo: Publicaciones.Tipos; } = null;
        public Tipos: { Nombre: string, Tipo: Publicaciones.Tipos; }[] = [
            { Nombre: 'Igual que la original', Tipo: null },
            { Nombre: 'Normal', Tipo: Publicaciones.Tipos.Normal },
            { Nombre: 'Financiada', Tipo: Publicaciones.Tipos.Financiada }
        ];
        public Precio: number = 0;
        public Stock: number = 0;

        public get Ok()
        {
            return this.Tipo && this.Cuenta && this.Precio >= 30 && this.Stock >= 1;
        }

        public async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Copiar publicaciones', `¿Copiar publicación a la cuenta ${this.Cuenta}?` ) )
            {

                this.Cargando = true;
                if ( this.Ok )
                {

                    let tipo = this.Tipo.Tipo ? this.Tipo.Tipo.Id : null;

                    let a = await this.Controlador.Publicacion.Duplicar( this.Cuenta, this.Precio, this.Stock, tipo );
                    if ( a )
                    {
                        Utiles.Notificaciones.Completado( 'Operación completada' );
                    } else
                    {
                        Utiles.Notificaciones.Error( 'Error al copiar publicación' );
                    }

                    await Wait( 100 );
                    this.Cargando = false;

                }

                this.Cargando = false;
                this.Cerrar();
            }


        }


        public Cargando: boolean = false;

        public async Cerrar()
        {
            this.$emit( 'cerrar' );
            this.Abierto = false;

        }
    }
